
import { cookie } from '../../../cookie/cookie'

// IIFE
let LocalStorage = ((key='portal') => {
    // taken from Mozilla website
    let storageAvailable = (type) => {
            try {
                let storage = window[type],
                    x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch (e) {
                return e instanceof DOMException && (
                    // everything except Firefox
                    e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === 'QuotaExceededError' ||
                    // Firefox
                    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                    // acknowledge QuotaExceededError only if there's something already stored
                    storage.length !== 0;
            }
        },
        isLocalStorage = storageAvailable('localStorage'),
        storeKey = key

    return {
        set(key, data) {
            let store = this.get(), encoded;
            store[key] = data;
            encoded = JSON.stringify(store);

            if (isLocalStorage) {
                localStorage.setItem(this.storeKey, encoded);
            }
            else {
                // cookies fallback
                cookie.set(this.storeKey, encoded);
            }
        },

        get(key) {
            let data, res;

            if (isLocalStorage) {
                data = localStorage.getItem(this.storeKey);
            }
            else {
                // cookies fallback
                data = cookie.get(this.storeKey);
            }
            res = JSON.parse(data || '{}');

            return key ? res[key] : res;
        },

        getOrNull(key) {
            let data = this.get(key);
            return !_.isEmpty(data) && data;
        },
        storeKey:storeKey
    }
});

export default LocalStorage;